import React from "react";
import { useNavigate } from "react-router-dom";

const RefundPolicy = () => {
  const navigate = useNavigate();

  const styles = {
    container: {
      minHeight: "100vh",
      backgroundColor: "#f5f5f5",
      padding: "20px",
      overflowY: "auto",
      height: "100vh",
    },
    contentWrapper: {
      maxWidth: "900px",
      margin: "0 auto",
      backgroundColor: "#ffffff",
      padding: "25px",
      borderRadius: "8px",
      boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
    },
    header: {
      textAlign: "center",
      marginBottom: "30px",
      paddingBottom: "20px",
      borderBottom: "2px solid #e0e0e0",
      display: "flex",
      alignItems: "center",
      gap: "10px",
    },
    title: {
      fontSize: "24px",
      lineHeight: "1.2",
      fontWeight: "bold",
      color: "#333",
      marginBottom: "10px",
      textAlign: "left",
    },
    section: {
      marginBottom: "30px",
    },
    sectionTitle: {
      fontSize: "20px",
      fontWeight: "600",
      color: "#444",
      marginBottom: "15px",
    },
    paragraph: {
      fontSize: "14px",
      lineHeight: "1.4",
      color: "#666",
      marginBottom: "15px",
      textAlign: "justify",
    },
    listItem: {
      fontSize: "14px",
      lineHeight: "1.8",
      color: "#666",
      marginBottom: "10px",
    },
    backButton: {
      cursor: "pointer",
      color: "#007bff",
      textDecoration: "none",
      boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
      height: "40px",
      width: "40px",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "18px",
      flexBasis: "60px",
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.contentWrapper}>
        <div style={styles.header}>
          <div style={styles.backButton} onClick={() => navigate(-1)}>
            <i className="mdi mdi-keyboard-backspace"></i>
          </div>
          <h1 style={styles.title}>Refund & Cancellation Policy</h1>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>Cancellation Policy</h2>
          <p style={styles.paragraph}>
            For cancellations, please contact us via our helpline number +91
            9408770877 or email support@adhyayanyatra.com. Requests submitted
            through either channel help us validate your identity and respond at
            the earliest.
          </p>
          <p style={styles.paragraph}>
            If a cancellation or refund request is received after 48 hours (two
            business days), or after the exam is conducted, it will not be
            acceptable.
          </p>
          <p style={styles.paragraph}>
            Users are encouraged to review the website, its features, and the
            available free tests before purchasing any paid plans.
          </p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>Refund Policy</h2>
          <p style={styles.paragraph}>
            If any user reports not being satisfied with our exam experience, we
            are happy to review the case.
          </p>
          <ul style={{ paddingLeft: "20px", marginBottom: "15px" }}>
            <li style={styles.listItem}>
              Refund requests must be raised within 7 business days from the
              purchase date.
            </li>
            <li style={styles.listItem}>
              A valid reason along with relevant supporting details should be
              shared so our support team can investigate the issue.
            </li>
            <li style={styles.listItem}>
              Approved refunds are processed after deducting the GST amount that
              was remitted at source.
            </li>
          </ul>
          <p style={styles.paragraph}>
            Once a refund is approved, it will be initiated to the original mode
            of payment. Processing timelines may vary based on the issuing bank
            or payment provider.
          </p>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicy;

